import { defineComponent as t, createBlock as n, openBlock as l, unref as r, mergeProps as p, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconDeal",
  __name: "IconDeal",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(c) {
    const o = c;
    return (d, e) => (l(), n(r(s), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        a("path", { d: "M14.874 12.923c1.057 0 1.915.827 1.915 1.846 0 1.02-.858 1.847-1.915 1.847-1.058 0-1.916-.827-1.916-1.847s.858-1.846 1.916-1.846m.557-4.921a.636.636 0 0 1 .855 0 .538.538 0 0 1 0 .797l-7.717 7.198a.636.636 0 0 1-.854 0 .538.538 0 0 1 0-.798l7.716-7.197M9.127 7.385c1.058 0 1.916.826 1.916 1.846s-.858 1.846-1.916 1.846c-1.057 0-1.915-.827-1.915-1.846 0-1.02.858-1.846 1.915-1.846" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M9.973 4.063c.951-1.417 3.103-1.417 4.054 0A.999.999 0 0 0 15.2 4.43c1.634-.608 3.374.61 3.28 2.297a.948.948 0 0 0 .725.961c1.692.435 2.357 2.407 1.253 3.717a.917.917 0 0 0 0 1.188c1.104 1.31.44 3.283-1.253 3.717a.948.948 0 0 0-.725.962c.094 1.685-1.646 2.904-3.28 2.297a.998.998 0 0 0-1.173.367c-.951 1.417-3.103 1.417-4.054 0a.999.999 0 0 0-1.174-.367c-1.634.606-3.374-.612-3.28-2.297a.947.947 0 0 0-.725-.962c-1.691-.435-2.356-2.407-1.252-3.717a.917.917 0 0 0 0-1.188c-1.104-1.31-.44-3.282 1.252-3.717a.948.948 0 0 0 .726-.96C5.425 5.042 7.165 3.824 8.8 4.43a1 1 0 0 0 1.174-.368m2.848.753a.998.998 0 0 0-1.643 0c-.62.924-1.83 1.303-2.895.906-.662-.245-1.367.248-1.33.93.062 1.1-.685 2.092-1.79 2.375-.684.176-.953.975-.506 1.506a2.263 2.263 0 0 1 0 2.935c-.447.53-.178 1.329.507 1.505 1.104.284 1.851 1.275 1.79 2.375-.038.682.667 1.175 1.329.93 1.066-.396 2.274-.018 2.895.907a.999.999 0 0 0 1.643 0c.62-.925 1.83-1.303 2.896-.907.662.246 1.366-.248 1.328-.93-.061-1.1.686-2.091 1.79-2.375.686-.176.955-.975.508-1.505a2.263 2.263 0 0 1 0-2.935c.447-.531.178-1.33-.508-1.506-1.104-.283-1.851-1.275-1.79-2.374.038-.683-.666-1.177-1.328-.93-1.066.396-2.275.017-2.896-.907",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
